import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromLeads from '@features/leads/shared/reducers/leads.reducer';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { Observable } from 'rxjs';
import { LoadingState } from '@shared/types/loading-state';
import { Lead } from '@shared/models/lead';
import { LeadFilters } from '@shared/models/lead-filters';
import { loadLeads } from '../actions/load-leads.actions';
import { loadLead } from '../actions/load-lead.actions';
import { createLead } from '../actions/create-lead.actions';
import { updateLead } from '../actions/update-lead.actions';
import { setLeadFilters } from '../actions/set-lead-filters.actions';

@Injectable({
  providedIn: 'root',
})
export class LeadsService {
  constructor(private store: Store) {}

  loadLead(leadId: number) {
    this.store.dispatch(loadLead({ leadId }));
  }

  loadLeads(filters: LeadFilters, paginationState: PaginationState, sorting: Sorting) {
    this.store.dispatch(loadLeads({ filters, paginationState, sorting }));
  }

  createLead(lead: Partial<Lead>) {
    this.store.dispatch(createLead({ lead }));
  }

  updateLead(lead: Partial<Lead>) {
    this.store.dispatch(updateLead({ lead }));
  }

  setLeadFilters(filters: LeadFilters) {
    this.store.dispatch(setLeadFilters({ filters }));
  }

  getLeadsLoadingText(): Observable<string | undefined> {
    return this.store.select(fromLeads.selectLeadsLoadingText);
  }

  getLeadsLoadingState(): Observable<LoadingState> {
    return this.store.select(fromLeads.selectLeadsLoadingState);
  }

  getLeadsPaginationState(): Observable<PaginationState> {
    return this.store.select(fromLeads.selectLeadsPaginationState);
  }

  getLeads(): Observable<Lead[]> {
    return this.store.select(fromLeads.selectAllLeads);
  }

  getLeadById(leadId: number): Observable<Lead | undefined> {
    return this.store.select(fromLeads.selectLeadById(leadId));
  }

  getLeadFilters(): Observable<LeadFilters | undefined> {
    return this.store.select(fromLeads.selectLeadFilters);
  }
}
